import {ServicesTaggingEnum} from 'main/analytics/gaTagsEnum';
import {
	AppointmentEnum,
	FeaturesEnum,
	HealthCardEnum,
	HomeEnum,
	PerksEnum,
	ServicesEnum,
} from 'presentation/constants';
import {useContractStatus} from 'presentation/hooks';
import {useHostName} from 'presentation/hooks/useHostName';
import IconNamesType from 'presentation/icons/IconNamesType';
import {useAccountInformation} from 'presentation/pages';

import {translations} from 'presentation/translations-new';
import {MenuListType} from './types';
import {MenuListTypeEnum} from '../../../../tests/constants/MenuListTypeEnum';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {useCongenereEligibilityStore} from 'presentation/pages/private/store/useCongenereEligibilityStore';
import {HEALTH_CARD_MENU_ITEM_ID} from './constants';

const {home, booking, healthCard, services, perks, network} = translations['pt-br'].others.sidebar;

export function useMenuList() {
	const {isNotredameSaude, isGndiSaoPaulo} = useHostName();
	const {
		flPlanoSomenteHospitalar,
		healthOnly,
		isResponsibleWithoutBenefits,
		isB2BAccess,
		isEarlyAccess,
		isPPOPlan,
	} = useAccountInformation();

	const {isEnabled: isBlockPPOFeatureFlagEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_BLOCK_PPO,
	);

	const isGndiSaoPauloPPO = isGndiSaoPaulo && isPPOPlan;
	const isNotredameSaudeHMO = isNotredameSaude && !isPPOPlan;

	const {isValid, isContractSuspended} = useContractStatus();

	const congenereEligibility = useCongenereEligibilityStore(state => state.congenereEligibility);

	const hideAppointment =
		isContractSuspended ||
		isResponsibleWithoutBenefits ||
		isB2BAccess ||
		(flPlanoSomenteHospitalar && healthOnly);

	const MENU_LIST: MenuListType[] = [
		{
			title: home,
			icon: 'home-filled' as IconNamesType,
			route: HomeEnum.HOME_PAGE,
			dataTestId: MenuListTypeEnum.HOME,
		},
		{
			title: services,
			icon: 'apps-filled' as IconNamesType,
			route: ServicesEnum.SERVICES,
			hidden:
				(isGndiSaoPauloPPO && isBlockPPOFeatureFlagEnabled) ||
				isNotredameSaudeHMO ||
				!isValid ||
				isB2BAccess ||
				isEarlyAccess,
			dataTestId: MenuListTypeEnum.SERVICES,
		},
		{
			title: booking,
			icon: 'calendar-add-filled' as IconNamesType,
			route: AppointmentEnum.APPOINTMENT,
			hidden:
				(isGndiSaoPauloPPO && isBlockPPOFeatureFlagEnabled) ||
				isNotredameSaudeHMO ||
				!isValid ||
				hideAppointment ||
				isB2BAccess ||
				isEarlyAccess ||
				isNotredameSaude ||
				congenereEligibility,
			dataTestId: MenuListTypeEnum.BOOKING,
		},
		{
			title: network,
			icon: 'stethoscope-default' as IconNamesType,
			hidden:
				(isGndiSaoPauloPPO && isBlockPPOFeatureFlagEnabled) ||
				isNotredameSaudeHMO ||
				!isValid ||
				!isNotredameSaude ||
				isB2BAccess ||
				isEarlyAccess ||
				congenereEligibility,
			dataTestId: MenuListTypeEnum.NETWORK,
		},
		{
			title: healthCard,
			icon: isNotredameSaude
				? ('id-card' as IconNamesType)
				: ('hapvida-logo' as IconNamesType),
			route: HealthCardEnum.HEALTH_CARD,
			hidden:
				(isGndiSaoPauloPPO && isBlockPPOFeatureFlagEnabled) ||
				isNotredameSaudeHMO ||
				isResponsibleWithoutBenefits ||
				isB2BAccess,
			dataTagId: ServicesTaggingEnum.CLICK_CARTEIRINHAS,
			dataTestId: MenuListTypeEnum.HEALTH_CARD,
			id: HEALTH_CARD_MENU_ITEM_ID,
		},
		{
			title: perks,
			icon: 'sell-filled' as IconNamesType,
			route: PerksEnum.PERKS,
			hidden:
				(isGndiSaoPauloPPO && isBlockPPOFeatureFlagEnabled) ||
				isNotredameSaudeHMO ||
				!isValid ||
				isResponsibleWithoutBenefits ||
				isB2BAccess ||
				congenereEligibility,
			dataTagId: ServicesTaggingEnum.CLICK_BENEFICIOS,
			dataTestId: MenuListTypeEnum.PERKS,
		},
	].filter(item => !item.hidden);

	return {
		MENU_LIST,
	};
}
